// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"356f825a","477":"0eb28e37","689":"0ef0e035","812":"18afe0e4","916":"57f4334f"}[chunkId] + ".chunk.js";
};